/**
 * @description Config Module Category
 */
export enum ConfigModuleCategory {
	COPY = 'ConfigModuleCategory.COPY',
	DEPENDENCY = 'ConfigModuleCategory.DEPENDENCY',
	PLUGIN = 'ConfigModuleCategory.PLUGIN',
	SETTINGS = 'ConfigModuleCategory.SETTINGS',
	VIEW = 'ConfigModuleCategory.VIEW',
	HOOK = 'ConfigModuleCategory.HOOK',
	RESOURCE = 'ConfigModuleCategory.RESOURCE',
	DIAGNOSTIC = 'ConfigModuleCategory.DIAGNOSTIC',
	AB_TEST = 'ConfigModuleCategory.AB_TEST',
}